import { render, staticRenderFns } from "./ContractOwners.vue?vue&type=template&id=2b70dca4&scoped=true&"
import script from "./ContractOwners.vue?vue&type=script&lang=js&"
export * from "./ContractOwners.vue?vue&type=script&lang=js&"
import style0 from "./ContractOwners.vue?vue&type=style&index=0&id=2b70dca4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b70dca4",
  null
  
)

export default component.exports